import MonitoringTypeDropDown from './MonitoringTypeDropDown';

interface IProps {
  isContinueMonitoring: Boolean;
  setContinueMonitoring: Function;
  setMonitoringType: Function;
  monitoringType: string;
}

const ContinueMonitoring: (props: IProps) => JSX.Element = ({
  isContinueMonitoring,
  setContinueMonitoring,
  setMonitoringType,
  monitoringType,
}) => {
  return (
    <div className="mt-4 p-relative d-flex gap-4 monitoring-checkbox align-items-center">
      <div className="custom-checkbox mb-0 d-inline-block">
        <input
          type="checkbox"
          id="monitoring"
          checked={!!isContinueMonitoring}
          onChange={() => {
            setContinueMonitoring(!isContinueMonitoring);
          }}
        />
        <label htmlFor="monitoring" className={`mb-0 ${isContinueMonitoring ? '' : 'disabled'}`}>
          Monitor for Alerts
        </label>
      </div>
      <MonitoringTypeDropDown
        isContinueMonitoring={isContinueMonitoring}
        setMonitoringType={setMonitoringType}
        monitoringType={monitoringType}
      />
    </div>
  );
};

export default ContinueMonitoring;
